import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ReducedProfile } from '@interfaces/profiles/reduced-profile';
import { AuthService } from '@services/auth.service';
import { ProfileService } from '@services/profile.service';
import { map } from 'rxjs';

export const ProfileSelectorGuard: CanActivateFn = (
	route,
	state,
	profileSrv = inject(ProfileService),
	authSrv = inject(AuthService)
) => {
	return profileSrv.getUserProfiles().pipe(
		map((result: ReducedProfile[]) => {
			if (result.length === 1) {
				authSrv.setCurrentProfile(result[0]);
                return false; // No need to show the profile selector if only one profile exists
			}
            return true;
		})
	);
};
